import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';

@Component({
    selector: 'app-excel-color-picker',
    templateUrl: './excel-color-picker.component.html',
    styleUrl: './excel-color-picker.component.css',
    standalone: false,
})
export class ExcelColorPickerComponent implements OnChanges {
    @Input() selectedColor: string;
    @Output() onColorSelected: EventEmitter<string> = new EventEmitter();
    @Output() onClosePicker: EventEmitter<void> = new EventEmitter();

    @ViewChild('colorElement') colorElement: ElementRef;

    pickerIsOpen: boolean = false;
    colorList: string[] = [
        '#C00000',
        '#FF0000',
        '#FFC000',
        '#FFFF00',
        '#92D050',
        '#00B050',
        '#00B0F0',
        '#0070C0',
        '#002060',
        '#7030A0',
        '#FFFFFF',
        '#000000',
    ];

    selectedColorHex: string = undefined;

    @HostListener('document:mousedown', ['$event'])
    clickOut(event: MouseEvent) {
        if (!this.colorElement.nativeElement.contains(event.target as Node)) {
            this.onClosePicker.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.selectedColor && changes.selectedColor) {
            const hexColor = '#' + this.selectedColor.match(/\d+/g).map(this.componentToHex).join('');
            if (hexColor) this.selectedColorHex = hexColor;
            else this.selectedColorHex = undefined;
            return;
        }
        this.selectedColorHex = undefined;
    }

    componentToHex(val) {
        const a = Number(val).toString(16).toUpperCase();
        return a.length === 1 ? '0' + a : a;
    }

    colorSelected(color) {
        this.onColorSelected.emit(color);
    }
}
